import axios from 'axios';
import router from '../../router/index'
axios.defaults.retryDelay = 1;
axios.defaults.retryDelay = 1000;
axios.defaults.withCredentials = true;
// 创建实例封装
let instance = axios.create({
  // 配置请求头
  headers:{
    'Content-Type':'application/json',
    // 'Authorization':document.cookie.match('session').input,
    // 'Cookie':document.cookie.match('session').input,
  },
  // baseURL:'http://www.csaln.cn'
  baseURL:'https://www.wangchenlab.cn'
});

// 为实例添加拦截器，在请求或响应被 then 或 catch 处理前拦截它们
// 添加请求拦截器
// instance.interceptors.request.use(
//   function (config) {
//     const Cookie = document.cookie.match('session').input;
//     if (Cookie) {
//       // config.headers.Authorization = Cookie;
//       config.headers['Authorization'] = Cookie;
//     }
//     return config;
//   },
//   function (error) {
//     //对请求错误做些什么
//     // console.log('error', error);
//     // console.log('errormessage', error.message);
//     return Promise.reject(error);
//   }
// );

instance.interceptors.response.use(

function(response){
  let responseErrorType = {
    '200':'请求成功',
    '500':'服务器出错',
  }
  let codeErrorType = {
    '400':'语法出错，缺少字段，解析错误',
    '401':'缺少用户登录信息',
    '403':'用户权限不足',
    '405':'请求方法错误',
  }
  if(response.status){
    //拦截响应，做统一处理
    console.log(response);
    // console.log(response.data.code)
    // if(response.status){
    //   console.log('第一层返回码：',response.status,responseErrorType[response.status])
    //   if(response.data.code)
    //   {
    //     console.log('第二层返回码：',response.data.code,codeErrorType[response.data.code])
    //     if(response.data.code==401)
    //     {
    //       router.push('/notlogin');
    //     }
    //   }
    // }
    return response;
  }
},
function(error){
  console.log('error',error)
  let responseErrorType = {
    '200':'请求成功',
    '401':'缺少登录信息，请先登录',
    '500':'服务器出错',
  }
  let config = error.config;
  if(error.response.status){
    alert(responseErrorType[error.response.status])
    return Promise.reject(error);
  }
}
);

export default instance;



// WEBPACK FOOTER //
// ./src/assets/js/http.js